<div class="row">
  <nb-card>
    <nb-card-body>Página principal de usuario con rol {{userSessionService.user.acl_roles[0]}}.</nb-card-body>
  </nb-card>
</div>
